<!-- 问题反馈 -->
<template>
    <div>
        <Panel title="配置模版管理">
            <template slot="buttons">
                <el-button title="查询" class="blue" @click="pageTable.handleLoad()" icon="el-icon-fa-search">查询</el-button>
                <el-button title="重置" class="yellow" @click="pageTable.handleReset()" icon="el-icon-fa-refresh">重置</el-button>
            </template>

            <el-form ref="queryForm" v-model="pageTable.param">
                <el-row>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="quester" label="配置名称">
                            <el-input v-model="pageTable.param.item_name"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </Panel>

        <Panel title="配置模版列表">
            <template slot="buttons">
                <el-button title="新增配置模版" class="green" icon="el-icon-fa-plus" @click="doAdd">添加</el-button>
                <el-button title="删除配置模版" class="red" icon="el-icon-fa-trash" @click="doSeleDel">删除</el-button>
            </template>
            <el-table highlight-current-row stripe border :data="pageTable.data" v-loading="pageTable.isLoading"
                      ref="table" @selection-change="handleSelectionChange" element-loading-spinner="el-icon-loading"
                      element-loading-text="数据加载中" height="calc(100vh - 280px)">
                <el-table-column prop="$rownum" label="NO." width="50" align="center"/>
                <el-table-column type="selection" align='center' width="50"></el-table-column>
                <el-table-column prop="itemname" label="配置名称" show-overflow-tooltip width="250"></el-table-column>
                <el-table-column prop="item" label="配置项" show-overflow-tooltip width="250"></el-table-column>
                <el-table-column prop="itemconf" label="配置模版" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button title="编辑" class="blue" @click="doEdit(scope.$index, scope.row)" icon="el-icon-fa-edit">编辑</el-button>
                        <el-button title="删除" class="red" @click="doDelete( scope.$index, scope.row)" icon="el-icon-fa-trash">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <export-ctrl class="pull-left" @export="pageTable.handleExport($event, $refs.table)"/>
            <el-pagination background :page-size.sync="pageTable.size" :current-page.sync="pageTable.curr" :total="pageTable.total"/>
        </Panel>

        <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="editor.show" title="配置模版编辑" width="60%">
            <div class="dialog-button">
                <el-button title="保存" class="blue" @click="refsaveMould" icon="el-icon-fa-save">保存</el-button>
            </div>
            <div v-if="editor.show">
                <mouldEdit ref="edit" :dat='postdat' @upd='()=>{editor.show = false; pageTable.handleLoad()}'></mouldEdit>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import MouldEdit from "./MouldEdit";
    import MouldApi from "./Mould";
    import {PageTable} from 'cnetong-core-frontend';

    export default {
        name: "Mould",
        components: {MouldEdit},
        data() {
            return {
                pageTable: new PageTable({
                    doLoad: MouldApi.queryMouldList,
                    autoLoad: true
                }),
                postdat: {},
                form: {
                    item_name: "",
                    orderField: "item_name"
                },
                table: {
                    data: []
                },
                editor: {
                    show: false,
                    loading: false
                },
                multipleSelection: []
            };
        },
        mounted() {
        },
        methods: {
            // 打开编辑页面
            async refsaveMould() {
                await this.confirm();
                this.$refs.edit.saveMould();
            },
            doEdit(index, rowData) {
                this.postdat = rowData;
                this.editor.show = true;
            },
            doAdd() {
                this.postdat = {};
                this.editor.show = true;
            },
            async doDelete(index, rowData) {
                try {
                    await this.confirm();
                    this.pageTable.isLoading = true;
                    await MouldApi.delMould([rowData.uuid]);
                    this.pageTable.handleLoad();
                } finally {
                    this.pageTable.isLoading = false;
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            async doSeleDel() {
                if (this.multipleSelection.length === 0) {
                    this.$message.warning("请选择数据！");
                }
                try {
                    await this.confirm();
                    this.pageTable.isLoading = true;
                    let array = this.multipleSelection.map(v => v.uuid);
                    await MouldApi.delMould(array)
                    this.pageTable.handleLoad();
                } finally {
                    this.pageTable.isLoading = false;
                }
            },
        }
    };
</script>
